export class SampleFileRequest {

    public userId!: string;
    public businessId!:string;
    public type!: string; //csv
    public fieldDelimiter!: string;
    public hasHeader:boolean = false;
    public startAtRow?: number;
  
    constructor(){
    }
}